var _circle, _circle2, _circle3, _circle4, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6839,
    height: 6839,
    viewBox: "0 0 6839 6839",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3419.5,
    cy: 3419.5,
    r: 3419.5,
    fill: "#A5FFB5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3419.5,
    cy: 3419.5,
    r: 3024.94,
    fill: "#73FF8C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3419.5,
    cy: 3419.5,
    r: 2630.38,
    fill: "#4DF16A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3419.5,
    cy: 3419.5,
    r: 2235.83,
    fill: "#37D753"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3432.65,
    cy: 3419.5,
    rx: 1801.81,
    ry: 1841.27,
    fill: "#23B93D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2557.57 3282.24C2790.66 3610.96 3019.2 3909.23 3228.86 4276.58C3570.64 3760.79 3919.09 3243.88 4455.11 2703.83L4337.87 2630.74C3896.01 3000.29 3543.9 3358.34 3222.22 3795.88C3059.94 3606.41 2793.5 3333.72 2627.98 3190.05L2557.57 3282.24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_1283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1950.98,
    height: 1972.66,
    fill: "white",
    transform: "translate(2610.84 2314.73) rotate(7.09052)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreen);
export default __webpack_public_path__ + "static/media/success_green.de8e8d812b394a2db53116b560b8ef18.svg";
export { ForwardRef as ReactComponent };